import { loadOneTap } from './load';
const IGNORE_REASONS = ['user_cancel', 'tap_outside'];
class GoogleOneTap {
    constructor(params) {
        this.handleResponse = (response) => {
            this.resolveResponse?.(response);
            delete this.resolveResponse;
        };
        this.initialize = () => loadOneTap().then(() => {
            window.google.accounts.id.initialize({
                client_id: this.clientId,
                callback: this.handleResponse
            });
        });
        this.prompt = () => {
            return new Promise((resolve, reject) => {
                this.resolveResponse = resolve;
                window.google.accounts.id.prompt((notification) => {
                    if (notification.isSkippedMoment() || notification.isNotDisplayed()) {
                        const reason = notification.getSkippedReason() ||
                            notification.getNotDisplayedReason();
                        reject(new Error(~IGNORE_REASONS.indexOf(reason)
                            ? 'Google One Tap was skipped by user'
                            : `Google One Tap was failed by ${reason}`));
                    }
                });
            });
        };
        this.disableAutoSelect = () => {
            window.google.accounts.id.disableAutoSelect();
        };
        this.cancel = () => {
            window.google.accounts.id.cancel();
        };
        const { clientId } = params;
        this.clientId = clientId;
    }
}
export { GoogleOneTap };
